import { render, staticRenderFns } from "./HeatmapLegendElement.vue?vue&type=template&id=265c751c&"
import script from "./HeatmapLegendElement.vue?vue&type=script&lang=js&"
export * from "./HeatmapLegendElement.vue?vue&type=script&lang=js&"
import style0 from "./HeatmapLegendElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
